import { PlacedSvg } from './strip-svg'
import type { MaterialEnvelope } from './live-calc'

/**
 * The zarf (free envelope), drawn with the strip's own conventions: ONE PAIR
 * of a material nested freely, and the frame around it is the TIGHT bounding
 * envelope the "X desi/çift" figure is read from — not an imposed strip width.
 * Same paper, same hairline, same height-driven sizing, same selection and
 * hover plumbing; the only difference is what the rectangle means, which the
 * block's header says in words — and that the rectangle is hung on the
 * envelope's own `originMm`, because the placer normalizes by whole grid cells
 * and leaves the box's sub-cell origin in the placements.
 */

export interface ZarfSvgProps {
  envelope: MaterialEnvelope
  /** Set-wide request index of the selected piece, or null. */
  selectedPiece: number | null
  hoverPiece?: number | null
  /** Numeral per request piece index — the rail's own numbering. */
  pieceLabels?: readonly string[]
  onSelect?: (pieceIndex: number) => void
  onHover?: (pieceIndex: number | null) => void
  className?: string
}

export function ZarfSvg({
  envelope,
  selectedPiece,
  hoverPiece = null,
  pieceLabels,
  onSelect,
  onHover,
  className,
}: ZarfSvgProps) {
  return (
    <PlacedSvg
      widthMm={envelope.widthMm}
      lengthMm={envelope.lengthMm}
      originMm={envelope.originMm}
      placements={envelope.placements}
      instances={envelope.instances}
      ariaLabel={`Zarf yerleşimi — ${envelope.placements.length} parça`}
      selectedPiece={selectedPiece}
      hoverPiece={hoverPiece}
      pieceLabels={pieceLabels}
      onSelect={onSelect}
      onHover={onHover}
      className={className}
    />
  )
}
